import { defineStore } from 'pinia'
import { CommunityBoardContent } from '@/api/Models/CommunityBoardContent'

export const useCommunityStore = defineStore({
  id: 'community',
  state: () => ({
    editCommunityData: {} as CommunityBoardContent, // 短视频详情点击编辑的数据
    isRefresh: false
  }),
  actions: {
    setEditCommunityData(data: CommunityBoardContent) {
      this.editCommunityData = data
    },
    setIsRefresh(data:boolean) {
      this.isRefresh = data
    }
  },
  getters: {
    getEditCommunityData(): CommunityBoardContent {
      return this.editCommunityData
    },
    getIsRefresh(): boolean {
      return this.isRefresh
    }
  }
})
